import axios from 'axios'

// URL base dell'API per le impostazioni dei comuni, recuperato dall'env file

const IMPOSTAZIONI_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'impostazioni'

const headers = { 'Content-Type': 'application/json' }

class ImpostazioniComuneService {
    /**
     * Salva o aggiorna le impostazioni di un comune nel sistema.
     * Effettua una richiesta POST a `/impostazioni/save` con le impostazioni del comune.
     *
     * @param {Object} imp - Oggetto contenente i dettagli delle impostazioni del comune da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    aggiornaImpostazioni(imp) {
        return axios.post(IMPOSTAZIONI_REST_API_URL + "/save", imp, headers);
    }
}

// Creazione dell'istanza per essere importata direttamente nei componenti
const impostazioniComuneServiceInstance = new ImpostazioniComuneService()
export default impostazioniComuneServiceInstance;